module.exports = __webpack_public_path__ + "img/05.b33d10bc.png";